import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import $ from "jquery";
import { useFormik, FormikProvider, Field } from "formik";
import React, { useState } from "react";
import { store } from "../../App";
import NavigationServicesHeader from "../../Header/NavigationServicesHeader";
import HousingService from "../../Services/HousingService";
import { Form, FormGroup, Col } from "react-bootstrap";
import moment from "moment-timezone";
import jsPDF from "jspdf";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { FaFileExcel } from "react-icons/fa";
import { Link } from "@mui/material";
import Swal from "sweetalert2";
import { GetDetails, ModuleHeader } from "../utils/commonFunctions";

function PaymentCementReleased() {
  const [tableEnable, setTableEnable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [distList, setDistList] = useState([]);
  const [DivdropList, setDivdropList] = useState([]);
  const [ConstDropList, setConstDropList] = useState([]);
  const [MandalDropList, setMandalDropList] = useState([]);
  const [VillageDropList, setVillageDropList] = useState([]);
  const [DistrictCode, setDistrictCode] = useState("");
  const [divisionCode, setDivisionCode] = useState("");
  const [ConstituencyCode, setConstCode] = useState("");
  const [distData, setDistData] = useState([]);
  const [phaseList, setPhaseList] = useState([]);
  const [schemesList, setSchemesList] = useState([]);
  const [displayDistDrop, setdisplayDistDrop] = useState(true);
  const [displayDivDrop, setdisplayDivDrop] = useState(false);
  const [displayConstDrop, setdisplayConstDrop] = useState(false);
  const [displayMandalDrop, setdisplayMandalDrop] = useState(false);
  const [displayVillageDrop, setdisplayVillageDrop] = useState(false);
  const [reportType, setReportType] = useState("District");
  const [area, setArea] = useState("All");
  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  const [displaydist, setDisplaydist] = useState("All");
  const distuser = localStorage.getItem("username");
  const districtname = displaydist;

  function ApHomesPDF() {
    const pageWidth = 210;
    const pageHeight = 297;
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [pageWidth, pageHeight],
    });
    const imgPath = "/img/APSHCL_logo.png";
    const ToDate = moment(formik2.values.todate).format("DD//MM/YYYY");
    const FromDate = moment(formik2.values.fromdate).format("DD//MM/YYYY");

    const report_type = formik2.values.report_type;

    const headingText3 = `Expenditure Report of ${districtname} District from ${FromDate} to ${ToDate} of type: ${report_type} Wise,User: ${distuser} `;
    const headingText2 =
      "Andhra Pradesh State Housing Corporation Limited (APSHCL)"; // New heading text (displayed first)
    const headingText4 =
      "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007";
    const fontSize = 12;
    doc.setFont("times new roman");
    const textWidth2 =
      (doc.getStringUnitWidth(headingText2) * fontSize) /
      doc.internal.scaleFactor;
    const textWidth3 =
      (doc.getStringUnitWidth(headingText3) * fontSize) /
      doc.internal.scaleFactor;
    const textWidth4 =
      (doc.getStringUnitWidth(headingText4) * fontSize) /
      doc.internal.scaleFactor;
    const tableYStart = 35; // You can adjust this value to control the space between text and the table
    doc.setFontSize(fontSize);
    const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2;
    doc.text(headingText2, xCoordinate2, 10); // Adjust the Y-coordinate as needed
    // Calculate the X-coordinate to center the third heading text
    const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2;
    const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2;
    doc.text(headingText4, xCoordinate4, 20); // Adjust the Y-coordinate (e.g., 20) as needed
    doc.text(headingText3, xCoordinate3, 30); // Adjust the Y-coordinate as needed
    doc.addImage(imgPath, "PNG", 7, 7, 25, 25); // Adjust the size as needed

    doc.autoTable({
      html: "#my-APHomesPDf",
      theme: "grid",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" },
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: {
        fontSize: 8,
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 },
    });

    doc.save("ExpenditureReport.pdf");
  }
  React.useEffect(() => {
    formik2.setFieldValue("report_type", "District");
    let params = {
      dist_code: 0,
      div_code: 0,
      cont_code: 0,
      mandal_code: 0,
      village_code: 0,
    };
    HousingService.AphomesDistrictMaster(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.dist_code}>
              {item.dist_name}
            </option>
          );
        });
        setDistList(options);
      }
    });
    HousingService.getAphomesPhasesDropdown().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.phase}>
              {item.phase_name}
            </option>
          );
        });
        setPhaseList(options);
      }
    });

    HousingService.getAphomesSchemesDropdown().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.scheme_id}>
              {item.scheme_name}
            </option>
          );
        });
        setSchemesList(options);
      }
    });
  }, []);

  const todayDate = new Date();

  let year = todayDate.getUTCFullYear();

  let month = todayDate.getMonth() + 1;

  let tDate = todayDate.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (tDate < 10) {
    tDate = "0" + tDate;
  }

  const maxDate = year + "-" + month + "-" + tDate;

  const CustomDateComponent = (props) => (
    <input
      className="my-custom-input"
      type="date"
      maxDate={maxDate}
      {...props}
    />
  );
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const firstDayOfMonth = `${currentYear}-${currentMonth
    .toString()
    .padStart(2, "0")}-01`;

  const currentDate = new Date();
  const currentDateString = currentDate.toISOString().split("T")[0];

  const handlereportType = (e) => {
    if (e.target.value === "District") {
      setdisplayDistDrop(true);
      setdisplayDivDrop(false);
      setdisplayConstDrop(false);
      setdisplayMandalDrop(false);
      setdisplayVillageDrop(false);
    } else if (e.target.value === "Division") {
      setdisplayDistDrop(true);
      setdisplayDivDrop(true);
      setdisplayConstDrop(false);
      setdisplayMandalDrop(false);
      setdisplayVillageDrop(false);
    } else if (e.target.value === "Constituency") {
      setdisplayDistDrop(true);
      setdisplayDivDrop(true);
      setdisplayConstDrop(true);
      setdisplayMandalDrop(false);
      setdisplayVillageDrop(false);
    } else if (e.target.value === "Mandal") {
      setdisplayDistDrop(true);
      setdisplayDivDrop(true);
      setdisplayConstDrop(true);
      setdisplayMandalDrop(true);
      setdisplayVillageDrop(false);
    } else if (e.target.value === "Panchayat") {
      setdisplayDistDrop(true);
      setdisplayDivDrop(true);
      setdisplayConstDrop(true);
      setdisplayMandalDrop(true);
      setdisplayVillageDrop(true);
    }
    // else if (e.target.value === "Schemewise") {
    //   setdisplayDistDrop(true);
    //   setdisplayDivDrop(false);
    //   setdisplayConstDrop(false);
    //   setdisplayMandalDrop(false);
    //   setdisplayVillageDrop(false);
    // }
    else {
      setdisplayDistDrop(true);
      setdisplayDivDrop(false);
      setdisplayConstDrop(false);
      setdisplayMandalDrop(false);
      setdisplayVillageDrop(false);
    }
    return;
  };
  const DistClick = (
    dist_code,
    div_code,
    cont_code,
    mandal_code,
    village_code,
    phase,
    scheme
  ) => {
    let params = {
      report_type: "Division",
      dist_code: dist_code,
      div_code: div_code,
      cont_code: cont_code,
      mandal_code: mandal_code,
      village_code: village_code,
      area: area,
      scheme_id: scheme,
      phase: phase,
      //   date: date,
      fromdate: fromdate,
      todate: todate,
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.AphomesPaymentCementReleasedReport(params).then((res) => {
      setTableData(res.data);
      if (res.data[0].dist_code != 0) {
        setDisplaydist(res.data[0].dist_name);
      } else {
        setDisplaydist("All");
      }
      $(function () {
        function tally(selector) {
          $(selector).each(function () {
            var total = 0,
              column = $(this).siblings(selector).addBack().index(this);
            $("#my-APHomesPDf tbody tr").each(function () {
              total +=
                parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
            });
            $(this).html(total);
          });
        }
        tally("td.total");
      });
      setReportType("Division");
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const DivClick = (
    dist_code,
    div_code,
    cont_code,
    mandal_code,
    village_code,
    phase,
    scheme
  ) => {
    let params = {
      report_type: "Constituency",
      dist_code: dist_code,
      div_code: div_code,
      cont_code: cont_code,
      mandal_code: mandal_code,
      village_code: village_code,
      area: area,
      scheme_id: scheme,
      phase: phase,
      //   date: date,
      fromdate: fromdate,
      todate: todate,
    };
    store.dispatch({ type: "SHOW_SPINNER" });

    HousingService.AphomesPaymentCementReleasedReport(params).then((res) => {
      setTableData(res.data);
      $(function () {
        function tally(selector) {
          $(selector).each(function () {
            var total = 0,
              column = $(this).siblings(selector).addBack().index(this);
            $("#my-APHomesPDf tbody tr").each(function () {
              total +=
                parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
            });
            $(this).html(total);
          });
        }
        tally("td.total");
      });
      setReportType("Constituency");
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const constClick = (
    dist_code,
    div_code,
    cont_code,
    mandal_code,
    village_code,
    phase,
    scheme
  ) => {
    let params = {
      report_type: "Mandal",
      dist_code: dist_code,
      div_code: div_code,
      cont_code: cont_code,
      mandal_code: mandal_code,
      village_code: village_code,
      area: area,
      scheme_id: scheme,
      phase: phase,
      //   date: date,
      deomdate: fromdate,
      todate: todate,
    };
    store.dispatch({ type: "SHOW_SPINNER" });

    HousingService.AphomesPaymentCementReleasedReport(params).then((res) => {
      setTableData(res.data);
      $(function () {
        function tally(selector) {
          $(selector).each(function () {
            var total = 0,
              column = $(this).siblings(selector).addBack().index(this);
            $("#my-APHomesPDf tbody tr").each(function () {
              total +=
                parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
            });
            $(this).html(total);
          });
        }
        tally("td.total");
      });
      setReportType("Mandal");
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const mandalClick = (
    dist_code,
    div_code,
    cont_code,
    mandal_code,
    village_code,
    phase,
    scheme
  ) => {
    let params = {
      report_type: "Panchayat",
      dist_code: dist_code,
      div_code: div_code,
      cont_code: cont_code,
      mandal_code: mandal_code,
      village_code: village_code,
      area: area,
      scheme_id: scheme,
      phase: phase,
      //   date: date,
      fromdate: fromdate,
      todate: todate,
    };
    store.dispatch({ type: "SHOW_SPINNER" });

    HousingService.AphomesPaymentCementReleasedReport(params).then((res) => {
      setTableData(res.data);
      setReportType("Panchayat");
      $(function () {
        function tally(selector) {
          $(selector).each(function () {
            var total = 0,
              column = $(this).siblings(selector).addBack().index(this);
            $("#my-APHomesPDf tbody tr").each(function () {
              total +=
                parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
            });
            $(this).html(total);
          });
        }
        tally("td.total");
      });
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const getDivList = (e) => {
    let DistCode = e.target.value;
    let params = {
      dist_code: DistCode,
      div_code: 0,
      cont_code: 0,
      mandal_code: 0,
      village_code: 0,
    };
    setDistrictCode(e.target.value);
    if (DistCode !== "0") {
      HousingService.AphomesDistrictMaster(params).then((res) => {
        if (res.data) {
          // if (values.report_type === "District") {
          //   if (values.district !== "0") {
          //     setDisplaydist(res.data[0].dist_name);
          //   } else {
          //     setDisplaydist("All");
          //   }
          // }
          let options = res.data.map((item, i) => {
            return (
              <option key={i} value={item.div_code}>
                {item.div_name}
              </option>
            );
          });
          setDivdropList(options);
        }
        formik2.setFieldValue("division", "0");
      });
    } else {
      setDivdropList([]);
    }
  };
  const getConstList = (e) => {
    let DivCode = e.target.value;
    let params = {
      dist_code: DistrictCode,
      div_code: DivCode,
      cont_code: 0,
      mandal_code: 0,
      village_code: 0,
    };
    setDivisionCode(e.target.value);
    if (DivCode !== "0") {
      HousingService.AphomesDistrictMaster(params).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => {
            return (
              <option key={i} value={item.cont_code}>
                {item.cont_name}
              </option>
            );
          });
          setConstDropList(options);
        }
        formik2.setFieldValue("Constituency", "0");
      });
    } else {
      setConstDropList([]);
    }
  };
  const getMandalList = (e) => {
    let ConstCode = e.target.value;
    let params = {
      dist_code: DistrictCode,
      div_code: divisionCode,
      cont_code: ConstCode,
      mandal_code: 0,
      village_code: 0,
    };
    setConstCode(e.target.value);
    if (ConstCode !== "0") {
      HousingService.AphomesDistrictMaster(params).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => {
            return (
              <option key={i} value={item.mandal_code}>
                {item.mandal_name}
              </option>
            );
          });
          setMandalDropList(options);
        }
        formik2.setFieldValue("Mandal", "0");
      });
    } else {
      setMandalDropList([]);
    }
  };
  const getVillageList = (e) => {
    let MandalCode = e.target.value;
    let params = {
      dist_code: DistrictCode,
      div_code: divisionCode,
      cont_code: ConstituencyCode,
      mandal_code: MandalCode,
    };
    if (MandalCode !== "0") {
      HousingService.AphomesDistrictMaster(params).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => {
            return (
              <option key={i} value={item.village_code}>
                {item.village_name}
              </option>
            );
          });
          setVillageDropList(options);
        }
        formik2.setFieldValue("Village", "0");
      });
    } else {
      setVillageDropList([]);
    }
  };

  const formik2 = useFormik({
    initialValues: {
      report_type: "District",
      area: "All",
      district: "0",
      phase: "0",
      scheme: "0",
      fromdate: firstDayOfMonth,
      todate: today.toISOString().substr(0, 10),
      Constituency: "0",
      Mandal: "0",
      Division: "0",
      Village: "0",
    },
    validate: (values) => {
      const errors = {};
      if (!values.fromdate) {
        errors.fromdate = "From date is required";
      }
      if (!values.todate) {
        errors.todate = "To date is required";
      }
      return errors;
    },

    onSubmit: (values) => {
      setReportType(formik2.values.report_type);
      setArea(values.area);
      //   setDate(values.date);
      setFromdate(values.fromdate);
      setTodate(values.todate);

      let params = {
        report_type: values.report_type,
        dist_code: values.district,
        div_code: values.Division,
        cont_code: values.Constituency,
        mandal_code: values.Mandal,
        village_code: values.Village,

        area: values.area,
        scheme_id: values.scheme,
        phase: values.phase,
        fromdate: values.fromdate,
        todate: values.todate,
      };
      store.dispatch({ type: "SHOW_SPINNER" });

      HousingService.AphomesPaymentCementReleasedReport(params)
        .then((res) => {
          setTableData(res.data);
          $(function () {
            function tally(selector) {
              $(selector).each(function () {
                var total = 0,
                  column = $(this).siblings(selector).addBack().index(this);
                $("#my-APHomesPDf tbody tr").each(function () {
                  total +=
                    parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
                });
                $(this).html(total);
              });
            }
            tally("td.total");
          });
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
          setTableEnable(true);
        });
    },
  });

  return (
    <>
      <NavigationServicesHeader />
      <FormikProvider value={formik2}>
        <Form onSubmit={formik2.handleSubmit}>
          <ModuleHeader title="Expenditure Report Upto 2022" />
          <OFMSUI.Container
            className="outer-page-content-container "
            fluid
            style={{ width: "90%" }}
          >
            <OFMSUI.Row>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className="mb-3"
              >
                <FormGroup as={Col}>
                  <label>
                    <b> Report Type</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    *
                  </span>
                  <Field
                    component="select"
                    name="report_type"
                    className={
                      formik2.touched.report_type && formik2.errors.report_type
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      formik2.handleChange(e);
                      handlereportType(e);
                    }}
                  >
                    <option value="District">District Wise</option>
                    <option value="Division">Division Wise</option>
                    <option value="Constituency">Constituency Wise</option>
                    <option value="Mandal">Mandal Wise</option>
                    <option value="Panchayat">Panchayat Wise</option>

                    {/* <option value="Schemewise">Scheme Wise</option> */}
                    <option value="Phase">Phase Wise</option>
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className="mb-3"
              >
                <FormGroup as={Col}>
                  <label>
                    <b> From Date</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    *
                  </span>
                  <Field
                    name="fromdate"
                    type="date"
                    max={maxDate}
                    as={CustomDateComponent}
                    onChange={(e) => formik2.handleChange(e)}
                    className={
                      formik2.touched.fromdate && formik2.errors.fromdate
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                  ></Field>
                  {formik2.touched.fromdate && formik2.errors.fromdate ? (
                    <div className="invalid-feedback">
                      {formik2.errors.fromdate}
                    </div>
                  ) : null}
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className="mb-3"
              >
                <FormGroup as={Col}>
                  <label>
                    <b> To Date</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    *
                  </span>
                  <Field
                    name="todate"
                    type="date"
                    max={maxDate}
                    as={CustomDateComponent}
                    onChange={(e) => formik2.handleChange(e)}
                    className={
                      formik2.touched.todate && formik2.errors.todate
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                  ></Field>
                  {formik2.touched.todate && formik2.errors.todate ? (
                    <div className="invalid-feedback">
                      {formik2.errors.todate}
                    </div>
                  ) : null}
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className="mb-3"
              >
                <FormGroup as={Col}>
                  <label>
                    <b> Area</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    *
                  </span>
                  <Field
                    component="select"
                    name="area"
                    onChange={(e) => {
                      formik2.handleChange(e);
                    }}
                    className={
                      formik2.touched.area && formik2.errors.area
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                  >
                    <option value="All">All</option>
                    <option value="Rural">Rural</option>
                    <option value="Urban">Urban</option>
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className="mb-3"
              >
                <FormGroup as={Col}>
                  <label>
                    <b> Phase</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    *
                  </span>
                  <Field
                    component="select"
                    name="phase"
                    className={
                      formik2.touched.phase && formik2.errors.phase
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                  >
                    <option value="0">All</option>
                    {phaseList}
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className="mb-3"
              >
                <FormGroup as={Col}>
                  <label>
                    <b>Scheme</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    *
                  </span>
                  <Field
                    component="select"
                    name="scheme"
                    className={
                      formik2.touched.scheme && formik2.errors.scheme
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                  >
                    <option value="0">All</option>
                    {schemesList}
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              {displayDistDrop && (
                <>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className="mb-3"
                  >
                    <FormGroup as={Col}>
                      <label>
                        <b> District</b>
                      </label>
                      <span className="mandatory" style={{ color: "red" }}>
                        *
                      </span>
                      <Field
                        component="select"
                        name="district"
                        onChange={(e) => {
                          getDivList(e);
                          formik2.handleChange(e);
                        }}
                        className={
                          formik2.touched.district && formik2.errors.district
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      >
                        <option value="0">All</option>
                        {distList}
                      </Field>
                    </FormGroup>
                  </OFMSUI.Col>
                </>
              )}
              {displayDivDrop && (
                <>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className="mb-3"
                  >
                    <FormGroup as={Col}>
                      <label>
                        <b> Division</b>
                      </label>
                      <span className="mandatory" style={{ color: "red" }}>
                        *
                      </span>
                      <Field
                        component="select"
                        name="Division"
                        onChange={(e) => {
                          getConstList(e);
                          formik2.handleChange(e);
                        }}
                        className={
                          formik2.touched.Division && formik2.errors.Division
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      >
                        <option value="0">All</option>
                        {DivdropList}
                      </Field>
                    </FormGroup>
                  </OFMSUI.Col>
                </>
              )}
              {displayConstDrop && (
                <>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className="mb-3"
                  >
                    <FormGroup as={Col}>
                      <label>
                        <b> Constituency</b>
                      </label>
                      <span className="mandatory" style={{ color: "red" }}>
                        *
                      </span>
                      <Field
                        component="select"
                        name="Constituency"
                        onChange={(e) => {
                          getMandalList(e);
                          formik2.handleChange(e);
                        }}
                        className={
                          formik2.touched.Constituency &&
                          formik2.errors.Constituency
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      >
                        <option value="0">All</option>
                        {ConstDropList}
                      </Field>
                    </FormGroup>
                  </OFMSUI.Col>
                </>
              )}
              {displayMandalDrop && (
                <>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className="mb-3"
                  >
                    <FormGroup as={Col}>
                      <label>
                        <b> Mandal</b>
                      </label>
                      <span className="mandatory" style={{ color: "red" }}>
                        *
                      </span>
                      <Field
                        component="select"
                        name="Mandal"
                        onChange={(e) => {
                          getVillageList(e);
                          formik2.handleChange(e);
                        }}
                        className={
                          formik2.touched.Mandal && formik2.errors.Mandal
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      >
                        <option value="0">All</option>
                        {MandalDropList}
                      </Field>
                    </FormGroup>
                  </OFMSUI.Col>
                </>
              )}
              {displayVillageDrop && (
                <>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className="mb-3"
                  >
                    <FormGroup as={Col}>
                      <label>
                        <b> Village</b>
                      </label>
                      <span className="mandatory" style={{ color: "red" }}>
                        *
                      </span>
                      <Field
                        component="select"
                        name="Village"
                        onChange={(e) => {
                          formik2.handleChange(e);
                        }}
                        className={
                          formik2.touched.Village && formik2.errors.Village
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      >
                        <option value="0">All</option>
                        {VillageDropList}
                      </Field>
                    </FormGroup>
                  </OFMSUI.Col>
                </>
              )}
              <GetDetails />
            </OFMSUI.Row>
            &nbsp;
            {tableEnable && (
              <>
                <div
                  style={{ overflow: "auto", margin: "0px", height: "620px" }}
                >
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={9}
                    lg={9}
                    xl={9}
                    xxl={9}
                    className=" mb-2 float-end"
                  >
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={ApHomesPDF}
                      style={{ float: "right", marginLeft: "3px" }}
                    >
                      PDF
                      <MdOutlinePictureAsPdf />
                    </button>
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      style={{ float: "right", color: "#fff" }}
                    >
                      <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button"
                        table="my-APHomesPDf"
                        filename="ExpenditureReport"
                        sheet="tablexls"
                        buttonText="Excel"
                      >
                        <FaFileExcel style={{ color: "#fff" }} />
                      </ReactHTMLTableToExcel>
                    </button>
                  </OFMSUI.Col>

                  <OFMSUI.Table
                    striped
                    bordered
                    hover
                    id="my-APHomesPDf"
                    indexid="index"
                    style={{ marginTop: "15px" }}
                  >
                    <thead
                      className="fw-bold"
                      style={{ position: "sticky", top: "0px" }}
                    >
                      <tr>
                        {" "}
                        <th colSpan={9} style={{ textAlign: "center" }}>
                          {" "}
                          <h6>
                          Expenditure Report Upto 2022 of {districtname} District from{" "}
                            {formik2.values.fromdate} to {formik2.values.todate}{" "}
                            of type: {formik2.values.report_type} Wise, User:
                            {distuser}
                          </h6>{" "}
                        </th>{" "}
                      </tr>
                      <tr className="table_countshead">
                        <th>S No.</th>
                        {reportType === "District" && <th>District</th>}
                        {reportType === "Division" && (
                          <th>District/Division</th>
                        )}
                        {reportType === "Constituency" && (
                          <th>District/Division/Constituency</th>
                        )}
                        {reportType === "Mandal" && (
                          <th>District/Division/Constituency/Mandal</th>
                        )}
                        {reportType === "Panchayat" && (
                          <th>
                            District/Division/Constituency/Mandal/Panchayat
                          </th>
                        )}
                        {/* {reportType === "Schemewise" && <th>Scheme Name</th>} */}

                        {reportType === "Phase" && <th>Phase</th>}

                        <th>No of Houses Completed</th>

                        <th>Payment</th>
                        <th>No of bags</th>
                        <th>Cement value</th>
                        <th>Material value</th>
                        <th>AF&BC Admin Charges</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData?.length === 0 ? (
                        <tr>
                          <td colSpan={16} style={{ textAlign: "center" }}>
                            {" "}
                            No Details Found
                          </td>{" "}
                        </tr>
                      ) : (
                        tableData?.map((tableData, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            {reportType === "District" && (
                              <td>
                                {" "}
                                <Link
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "none",
                                  }}
                                  onClick={() =>
                                    DistClick(
                                      tableData.dist_code,
                                      0,
                                      0,
                                      0,
                                      0,
                                      0,
                                      0
                                    )
                                  }
                                >
                                  {tableData.dist_name}
                                </Link>{" "}
                              </td>
                            )}
                            {reportType === "Division" && (
                              <td>
                                {tableData.dist_name} /{" "}
                                <Link
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "none",
                                  }}
                                  onClick={() =>
                                    DivClick(
                                      tableData.dist_code,
                                      tableData.div_code,
                                      0,
                                      0,
                                      0,
                                      0,
                                      0
                                    )
                                  }
                                >
                                  {tableData.div_name}
                                </Link>{" "}
                              </td>
                            )}
                            {reportType === "Constituency" && (
                              <td>
                                {tableData.dist_name} / {tableData.div_name}/
                                <Link
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "none",
                                  }}
                                  onClick={() =>
                                    constClick(
                                      tableData.dist_code,
                                      tableData.div_code,
                                      tableData.cont_code,
                                      0,
                                      0,
                                      0,
                                      0
                                    )
                                  }
                                >
                                  {tableData.cont_name}
                                </Link>{" "}
                              </td>
                            )}
                            {reportType === "Mandal" && (
                              <td>
                                {tableData.dist_name} / {tableData.div_name}/
                                {tableData.cont_name}/{" "}
                                <Link
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "none",
                                  }}
                                  onClick={() =>
                                    mandalClick(
                                      tableData.dist_code,
                                      tableData.div_code,
                                      tableData.cont_code,
                                      tableData.mandal_code,
                                      0,
                                      0,
                                      0
                                    )
                                  }
                                >
                                  {tableData.mandal_name}
                                </Link>{" "}
                              </td>
                            )}
                            {reportType === "Panchayat" && (
                              <td>
                                {" "}
                                {tableData.dist_name} / {tableData.div_name}/
                                {tableData.cont_name}/{tableData.mandal_name}/
                                {tableData.village_name}{" "}
                              </td>
                            )}

                            {/* {reportType === "Schemewise" && (
                              <td> {tableData.scheme_name}</td>
                            )} */}

                            {reportType === "Phase" && (
                              <td> {tableData.phase_name}</td>
                            )}
                            <td>{tableData.total}</td>
                            <td> {tableData.payment}</td>
                            <td>{tableData.no_of_bags}</td>
                            <td>{tableData.cement}</td>
                            <td>{tableData.material}</td>
                            <td>{tableData.admin_charges}</td>
                            <td>
                              {parseInt(tableData.admin_charges) +
                                parseInt(tableData.payment) +
                                parseInt(tableData.cement) +
                                parseInt(tableData.material)}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: "0px" }}>
                      <tr className="table_countshead">
                        {tableData?.length > 0 ? (
                          <>
                            <td colSpan={2} style={{ textAlign: "center" }}>
                              Total
                            </td>
                            <td>
                              {tableData
                                .reduce(
                                  (a, v) => a + parseFloat(v.total || 0),
                                  0
                                )
                                .toLocaleString("en-IN")}
                            </td>
                            <td>
                              {tableData
                                .reduce(
                                  (a, v) => a + parseFloat(v.payment || 0),
                                  0
                                )
                                .toLocaleString("en-IN")}
                            </td>
                            <td>
                              {tableData
                                .reduce(
                                  (a, v) => a + parseFloat(v.no_of_bags || 0),
                                  0
                                )
                                .toLocaleString("en-IN")}
                            </td>
                            <td>
                              {tableData
                                .reduce(
                                  (a, v) => a + parseFloat(v.cement || 0),
                                  0
                                )
                                .toLocaleString("en-IN")}
                            </td>
                            <td>
                              {tableData
                                .reduce(
                                  (a, v) => a + parseFloat(v.material || 0),
                                  0
                                )
                                .toLocaleString("en-IN")}
                            </td>
                            <td>
                              {tableData
                                .reduce(
                                  (a, v) =>
                                    a + parseFloat(v.admin_charges || 0),
                                  0
                                )
                                .toLocaleString("en-IN")}
                            </td>
                            <td>
                              {tableData
                                .reduce(
                                  (a, v) =>
                                    a +
                                    (parseFloat(v.payment || 0) +
                                      parseFloat(v.cement || 0) +
                                      parseFloat(v.material || 0) +
                                      parseFloat(v.admin_charges || 0)),
                                  0
                                )
                                .toLocaleString("en-IN")}
                            </td>
                          </>
                        ) : (
                          <tr></tr>
                        )}
                      </tr>
                    </tfoot>
                  </OFMSUI.Table>
                </div>
              </>
            )}
          </OFMSUI.Container>
        </Form>
      </FormikProvider>
    </>
  );
}
export default PaymentCementReleased;
